import React from 'react';
import LinkButton from '../atoms/LinkButton';
import ResponsiveLazyImage from '../atoms/ResponsiveLazyImage';

const AudienceBand = ({
  heading = 'Bring the field into your learning community.',
  body = "Let's explore how footyLab could fit your students and your setting.",
  ctaLabel = 'Start the Conversation',
  ctaTo = '/contact',
  imageSrc = '/Staff_Smiles.JPG',
  imageAlt = 'DataRook staff with program participants',
}) => (
  <section className="py-16 md:py-20 bg-navy text-white">
    <div className="dr-container">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-yellow">{heading}</h2>
          <p className="text-lg md:text-xl mb-8 max-w-prose text-white/95">{body}</p>
          <LinkButton to={ctaTo} variant="primary" className="text-lg py-3 px-6">
            {ctaLabel}
          </LinkButton>
        </div>
        <ResponsiveLazyImage
          originalSrc={imageSrc}
          alt={imageAlt}
          className="w-full rounded-2xl object-cover aspect-[4/3] shadow-lg"
          loading="lazy"
          width={1280}
          height={960}
        />
      </div>
    </div>
  </section>
);

export default AudienceBand;
